#include <begin_vertex>

if (uHovered || uTutorial || uInvalid) {
  // pulse between 1 and 1.1
  transformed *= 0.9 + 0.05 * (sin(uTime * 10.0) + 1.0);
}
